import Vue from 'vue'
import Router from 'vue-router'
import Order from '@/components/Order'
import Login from '@/components/Login'
import ConfirmOrder from '@/components/ConfirmOrder'
import SuccessfulOrder from '@/components/SuccessfulOrder'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Order',
			component: Order
		},
		{
			path: '/confirmOrder',
			name: 'ConfirmOrder',
			component: ConfirmOrder
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '/success',
			name: 'Success',
			props: true,
			component: SuccessfulOrder
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js